import { render, staticRenderFns } from "./LoadParcelsToBus.vue?vue&type=template&id=70b1825a&"
import script from "./LoadParcelsToBus.vue?vue&type=script&lang=js&"
export * from "./LoadParcelsToBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports